<template>
    <div class="d-flex justify-center align-center">
        <span class="mx-5">Dashboard style:</span>
        <v-btn-toggle v-model="current" rounded color="primary" @change="setStyle">
            <v-btn small value="light">Light</v-btn>
            <v-btn small value="dark">Dark</v-btn>
        </v-btn-toggle>
    </div>
</template>

<script>
export default {
    name: 'StyleChanger',
    props: {
        default: {
            type: String,
            default: 'light',
            validator: val => ['light', 'dark'].includes(val)
        },
        paramKey: {
            type: String,
            default: 'dashboard_style'
        }
    },
    data:() => ({ current: 'light' }),
    created() {
        this.current = this.getBrowserPreference();
    },
    methods: {
        isStorageAvailable(api = 'localStorage') {
            let storage, x;
            try {
                storage = window[api], x = '__storage_test__';
                storage.setItem(x, x);
                storage.removeItem(x);
                return true;
            }
            catch(e) {
                return e instanceof DOMException && (
                    // everything except Firefox
                    e.code === 22 ||
                    // Firefox
                    e.code === 1014 ||
                    // test name field too, because code might not be present
                    // everything except Firefox
                    e.name === 'QuotaExceededError' ||
                    // Firefox
                    e.name === 'NS_ERROR_DOM_QUOTA_REACHED'
                ) &&
                // acknowledge QuotaExceededError only if there's something already stored
                storage.length !== 0;
            }
        },
        getBrowserPreference() {
            return !this.isStorageAvailable() ? this.default :
                localStorage.getItem(this.paramKey) || this.default;
        },
        setStyle() {
            this.$vuetify.theme.dark = this.current === 'dark';
            if (this.isStorageAvailable()) localStorage.setItem(this.paramKey, this.current);
        }
    }
}
</script>